import { render, staticRenderFns } from "./boyixuetang.vue?vue&type=template&id=3c2a25b8&scoped=true"
import script from "./boyixuetang.vue?vue&type=script&lang=js"
export * from "./boyixuetang.vue?vue&type=script&lang=js"
import style0 from "./boyixuetang.vue?vue&type=style&index=0&id=3c2a25b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2a25b8",
  null
  
)

export default component.exports